module.exports = __webpack_public_path__ + "img/shangye_zhongzidasha_suoluetu.e2dd92f5.png";